import { render, staticRenderFns } from "./InsideTeam.vue?vue&type=template&id=82e99d9c&scoped=true"
import script from "./InsideTeam.vue?vue&type=script&lang=js"
export * from "./InsideTeam.vue?vue&type=script&lang=js"
import style0 from "./InsideTeam.vue?vue&type=style&index=0&id=82e99d9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e99d9c",
  null
  
)

export default component.exports